
const headers = [
    {
      label: 'ชื่อ',
      field: 'name',
    },
    {
      label: 'สิทธิ์',
      field: 'role',
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
    {
      label: 'INFO',
      field: 'info',
      tdClass: 'text-center',
    },
  ]

  export default headers